module.exports = __webpack_public_path__ + "cancellara-dist/img/welfare-bit.620035f8.png";